import { useLocation } from "wouter";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Gift, BookOpen, Library } from "lucide-react";

export default function ChefAiqLibrary() {
  const [, setLocation] = useLocation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          <BookOpen className="h-8 w-8" />
          ChefAiQ Library
        </h1>
        <p className="text-muted-foreground">
          Manage content available to all ChefAiQ users
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <Card
          className="cursor-pointer hover:bg-accent/50 transition-colors"
          onClick={() => setLocation("/chefaiq-library/recipes")}
        >
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Library className="h-5 w-5" />
              Library Recipes
            </CardTitle>
            <CardDescription>
              Free template recipes shown to all ChefAiQ users at /library/chefaiq-library
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" onClick={(e) => { e.stopPropagation(); setLocation("/chefaiq-library/recipes"); }}>
              Manage Recipes
            </Button>
          </CardContent>
        </Card>

        <Card
          className="cursor-pointer hover:bg-accent/50 transition-colors"
          onClick={() => setLocation("/starter-pack")}
        >
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Gift className="h-5 w-5" />
              Starter Kit
            </CardTitle>
            <CardDescription>
              Template ingredients, materials, and equipment that new users can import to quickly set up their pantry
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" onClick={(e) => { e.stopPropagation(); setLocation("/starter-pack"); }}>
              Manage Starter Kit
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
